import React from 'react';

// Hooks
import { useTranslation } from 'Shared/utils/hooks/use-translation';

// Components
import { WpBadge, Size } from 'Wpds/components/badge';
import { WpTooltip, WpTooltipTrigger, WpTooltipContent } from 'Wpds/components/tooltip';

type Props = {
  size?: Size;
  tooltip?: string;
};

const BetaBadge = ({ size = 'sm', tooltip }: Props) => {
  const { tr } = useTranslation();
  const badgeContent = (
    <WpBadge color="gray" size={size} variant="outline">
      {tr('common.beta')}
    </WpBadge>
  );

  if (!tooltip) {
    return badgeContent;
  }

  return (
    <WpTooltip>
      <WpTooltipTrigger>{badgeContent}</WpTooltipTrigger>
      <WpTooltipContent>{tooltip}</WpTooltipContent>
    </WpTooltip>
  );
};

export default BetaBadge;
